import React, { useEffect, useRef, useState } from 'react';
import styles from "../css/Audio.module.css";
import Box from "components/inputs/Box";
import Button from "components/inputs/Button";
import { Chip } from "@mui/material";
import Swal from "sweetalert2";
import CircularProgress from '@mui/material/CircularProgress';

import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import ExhibitionSelect from "components/form/ExhibitionSelect";
import AudioModal from "./AudioModal";
import SubTopicListDnd from "./SubTopicListDnd";

import AudioService from "service/apiConfig/AudioService";
import ExhibitionService from "service/apiConfig/ExhibitionService";
import { audioActions } from "reducers/audio";
import {commonActions} from "../../reducers/common";


const Audio = () => {
    const category = ['일반', '어린이', '시각장애인', '영어'];
    const history = useHistory();
    const dispatch = useDispatch();
    const typeSelect = useSelector(state => state.audioData.typeSelect);
    const exhibitionSelect = useSelector(state => state.audioData.exhibitionSelect);
    const create = useSelector(state => state.audioData.create);
    const subTopicListDt = useSelector(state => state.audioData.subTopicList);

    const { typeId, roomId } = typeSelect;
    const [subTopicList, setSubTopicList] = useState(subTopicListDt);
    const [data, setData] = useState(false);
    const [loadingSelect, setLoadingSelect] = useState(false);
    const focusRef = useRef(null);

    const exhList = [];
    exhibitionSelect.forEach(list => {
        exhList.push(list.id);
    })

    useEffect(() => {
        ExhibitionService.getAll(1)
            .then(response => {
                dispatch(audioActions.setTypeSelect({...typeSelect, typeId: 1}));
                if (response.data.data.length >= 1) {
                    dispatch(audioActions.setExhibitionSelect(response.data.data));
                }
            })
            .catch(err => console.log(err));
    }, []);

    const handleSelect = (typeId) => {
        dispatch(audioActions.setTypeSelect({...typeSelect, typeId: typeId, roomId: typeSelect.roomId ? typeSelect.roomId : 0}));
        setLoadingSelect(true);
        ExhibitionService.getAll(typeId === 4 ? 2 : 1)
            .then(response => {
                focusRef.current.focus();
                dispatch(audioActions.setExhibitionSelect(response.data.data));
                setLoadingSelect(false);
            })
            .catch(err => console.log(err));
    }
    const handleExhibitionSelect = (e) => {
        dispatch(audioActions.setTypeSelect({ ...typeSelect, roomId: e.target.value }));
    }
    const handleSearch = () => {
        if (!exhList.includes(roomId)) {
            Swal.fire({
                text: "전시관 명칭을 선택해주세요.",
                icon: 'info',
                confirmButtonText: '확인',
            }).then((r) => {
                return false;
            })
        } else {
            dispatch(commonActions.trueIsLoading());
            if (typeId === 4) {
                AudioService.getAll(roomId, 1)
                    .then(response => {
                        dispatch(commonActions.falseIsLoading());
                        if (response.data.data.length === 0) {
                            setData(false);
                        } else {
                            setData(true)
                        }
                        dispatch(audioActions.setSubTopicList(response.data.data));
                        setSubTopicList(response.data.data);
                    })
                    .catch(err => console.log(err));
            } else {
                AudioService.getAll(roomId, typeId)
                    .then(response => {
                        dispatch(commonActions.falseIsLoading());
                        if (response.data.data.length === 0) {
                            setData(false);
                        } else {
                            setData(true)
                        }
                        dispatch(audioActions.setSubTopicList(response.data.data));
                        setSubTopicList(response.data.data);
                    })
                    .catch(err => console.log(err));
            }
        }
    }
    const handleSeqIndex = () => {
        AudioService.updateSeq(subTopicList)
            .then(response => {
                Swal.fire({
                    text: '저장이 완료되었습니다.',
                    icon: 'success',
                    confirmButtonText: '확인',
                }).then((result) => {
                    if (result.isConfirmed) {
                        history.push('/setting/audio');
                    } else return false;
                })
            })
            .catch(err => console.log(err));
    }
    return (
        <>
            <section className={`${styles.audioWrap}`}>
                <header>
                    <h2>오디오 관리</h2>
                </header>
                <Box>
                    <Box style={{marginBottom: '1rem'}}>
                        <div className={styles.audioSelectContainer}>
                            <Chip label="카테고리" sx={{marginRight: "1rem"}}/>
                            {category.map((title, index) => (
                                <div key={title} className={styles.inputBox}>
                                    <Button className={`${styles.categoryBtn} ${typeId === index + 1 ? styles.active : ''}`}
                                            onClick={() => handleSelect(index + 1)}>{title}</Button>
                                </div>
                            ))}
                        </div>
                        <div className={styles.audioSelectContainer}>
                            <Chip label="전시관" sx={{marginRight: "1rem"}}/>
                            <ExhibitionSelect
                                name={"exhibitionSelect"}
                                title={"명칭"}
                                list={exhibitionSelect}
                                value={exhList.includes(roomId) ? roomId : 0}
                                onChange={handleExhibitionSelect}
                                focusRef={focusRef}
                            />
                            <div style={{ marginLeft: "1rem", width: "30px", height: "30px" }}>
                                {loadingSelect && <CircularProgress sx={{ }} color="inherit" />}
                            </div>
                        </div>
                        <div className={styles.audioSelectContainer}>
                            <Button onClick={handleSearch} style={{ margin: "0 auto", background: "#5a54a1" }} type={"button"}>조회</Button>
                        </div>
                    </Box>
                    <Box>
                        <div className={styles.subHeader}>
                            <span className="caption">* 정렬 순서를 바꾼 후 저장 버튼을 클릭해주세요.</span>
                            <Button onClick={handleSeqIndex}>저장</Button>
                        </div>
                        <ul className={styles.subList}>
                            {data ?
                                <SubTopicListDnd
                                    subTopicList={subTopicList}
                                    subTopicListDt={subTopicListDt}
                                    setSubTopicList={setSubTopicList}
                                />
                                : <p className={"noData"} style={{ paddingBottom: "3rem" }}>전시 관리에서 중제목을 등록해주세요.</p>
                            }
                        </ul>
                    </Box>
                </Box>
            </section>
            <AudioModal create={create} subTopicList={subTopicList} setSubTopicList={setSubTopicList} />
        </>
    );
};

export default Audio;